/**
 * Frontend exam result runtime.
 */

import * as lpUtils from 'lpExamsAssetsJsPath/utils.js';

export class ExamResult {
	static selectors = {
		result: '.lp-exam-result',
		printResult: '.lp-exam-result__print',
	};

	static classes = {
		printing: 'lp-exam-result-printing',
		printParent: 'lp-exam-result-print-parent',
	};

	constructor() {
		this.events();
	}

	events() {
		if ( ExamResult._loadedEvents ) {
			return;
		}

		ExamResult._loadedEvents = this;

		lpUtils.eventHandlers( 'click', [
			{ selector: ExamResult.selectors.printResult, class: this, callBack: this.printResult.name },
		] );
	}

	printResult( args ) {
		if ( args.e ) {
			args.e.preventDefault();
		}

		const button = args.target?.closest( ExamResult.selectors.printResult );
		const result = button?.closest( ExamResult.selectors.result );
		if ( ! result ) {
			return;
		}

		const printParents = [];
		let parent = result.parentElement;

		while ( parent && parent !== document.body ) {
			parent.classList.add( ExamResult.classes.printParent );
			printParents.push( parent );
			parent = parent.parentElement;
		}

		document.body.classList.add( ExamResult.classes.printing );

		try {
			window.print();
		} finally {
			document.body.classList.remove( ExamResult.classes.printing );
			printParents.forEach( ( printParent ) => {
				printParent.classList.remove( ExamResult.classes.printParent );
			} );
		}
	}
}
